import Loadable from 'react/components/loadable';

const PosSettingsDrawer = Loadable({
  loader: () => import('../../pages/pos/pos_settings'),
  type: 'drawer',
});

angular.module('gym').value('PosSettingsDrawer', PosSettingsDrawer);
